/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Filter,
  ListAccountsOrderParameterInner,
  ListClubhouseRequestDataForAccount200Response,
} from '../models/index';
import {
    FilterFromJSON,
    FilterToJSON,
    ListAccountsOrderParameterInnerFromJSON,
    ListAccountsOrderParameterInnerToJSON,
    ListClubhouseRequestDataForAccount200ResponseFromJSON,
    ListClubhouseRequestDataForAccount200ResponseToJSON,
} from '../models/index';

export interface ListClubhouseRequestDataForAccountRequest {
    accountID: string;
    pageNumber?: number;
    pageSize?: number;
    filters?: Array<Filter>;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface ListPendingClubhouseReservationRequestDataRequest {
    pageNumber?: number;
    pageSize?: number;
    filters?: Array<Filter>;
    order?: Array<ListAccountsOrderParameterInner>;
}

/**
 * 
 */
export class ReserveClubhouseRequestDataApi extends runtime.BaseAPI {

    /**
     * List all clubhouse reservation requests for a specific account
     * List Requests for Account
     */
    async listClubhouseRequestDataForAccountRaw(requestParameters: ListClubhouseRequestDataForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClubhouseRequestDataForAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling listClubhouseRequestDataForAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests-data/account/{accountID}`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListClubhouseRequestDataForAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * List all clubhouse reservation requests for a specific account
     * List Requests for Account
     */
    async listClubhouseRequestDataForAccount(requestParameters: ListClubhouseRequestDataForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClubhouseRequestDataForAccount200Response> {
        const response = await this.listClubhouseRequestDataForAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List pending requests
     * List Pending Requests
     */
    async listPendingClubhouseReservationRequestDataRaw(requestParameters: ListPendingClubhouseReservationRequestDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClubhouseRequestDataForAccount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests-data/pending`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListClubhouseRequestDataForAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * List pending requests
     * List Pending Requests
     */
    async listPendingClubhouseReservationRequestData(requestParameters: ListPendingClubhouseReservationRequestDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClubhouseRequestDataForAccount200Response> {
        const response = await this.listPendingClubhouseReservationRequestDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
